<template>
    <div class="dot-third" :class="dotClass" />
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return [
                    'contact',
                    'client',
                    'prospect',
                    'supplier',
                    'company',
                    'individual',
                    'archived',
                    'reference',
                    'custom',
                ].includes(value);
            },
        },
    },
    computed: {
        dotClass() {
            return `dot-third--${this.type}`;
        },
    },
};
</script>
<style lang="scss" scoped>
.dot-third {
    border: 1px solid transparent;
    border-radius: 50%;
    display: inline-block;
    height: 9px;
    width: 9px;

    &--company {
        background-color: var(--colors-component-background-information-tag-directory-company);
        border-color: var(--colors-component-border-tag-directory-company);
    }

    &--client {
        background-color: var(--colors-component-background-information-tag-directory-customer);
        border-color: var(--colors-component-border-tag-directory-customer);
    }

    &--prospect {
        background-color: var(--colors-component-background-information-tag-directory-prospect);
        border-color: var(--colors-component-border-tag-directory-prospect);
    }

    &--supplier {
        background-color: var(--colors-component-background-information-tag-directory-supplier);
        border-color: var(--colors-component-border-tag-directory-supplier);
    }

    &--individual {
        background-color: var(--colors-component-background-information-tag-directory-individual);
        border-color: var(--colors-component-border-tag-directory-individual);
    }
}
</style>
